import CheckInConfig  from "./CheckInConfig";

export default CheckInConfig;